/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import {
  TaskDataModel,
  TaskDataObject,
  TaskDatumModel,
  TaskDatumType
} from '../../../../../../../models/task.model';
import { Logger, LogService } from '@epg/angular-base-lib';

@Component({
  selector: 'app-object-item',
  templateUrl: './object-item.component.html',
  styleUrls: ['./object-item.component.scss'],
  standalone: false
})
export class ObjectItemComponent implements OnInit {
  @Input() objectItem: TaskDataObject = new TaskDataObject(new Map<string, TaskDatumModel>());

  TaskDatumType = TaskDatumType;
  private log: Logger;
  noSort = () => 0;

  constructor(private logService: LogService) {
    this.log = logService.getLogger(this);
  }

  ngOnInit(): void {
    this.log.debug(this.objectItem);
  }
}
